<!-- Breaking Source EPG -->
<template>
  <div class="BreakingSourceEpg" id="BreakingSourceEpg">
    <!-- v-if="IsShowIcon" -->
    <div class="shezhi" @click="OpenSetting">
      <i class="iconfont icon-settings_btnCopy"></i>
    </div>
    <el-dialog
      :title="$t('lang.BreakingSourceEpg')"
      :visible.sync="BreakingSourceSwitch"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="BreakingSourceSetting">
        <div class="formTitle"><span>*</span>{{ $t('lang.EPGTitle') }}</div>
        <div class="formInput">
          <el-input v-model="BreakingSourceSetting.title" :placeholder="$t('lang.EPGNameDefault')"></el-input>
        </div>
        <div class="formTitle">{{ $t('lang.SourceEPGDuration') }}</div>
        <div class="formInput" id="formInput" >
          <el-select
            v-model="EPGTypeValue"
            @change="EPGTypeChange"
            :placeholder="$t('lang.select')">
            <el-option
              v-for="item in EPGTypeList"
              :key="item.value"
              :label="$t(`lang.${item.label}`)"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="formTitle">{{ $t('lang.EPGDescription') }}</div>
        <div class="formInput">
          <el-input
            type="textarea"
            :rows="2"
            :placeholder="$t('lang.TextareaEnter')"
            v-model="BreakingSourceSetting.description">
          </el-input>
        </div>
      </div>
      <div class="CustomTime" v-show="TimeSelectSwitch">
          <div class="CustomTimeHead">
            <div class="name">
              {{$t('lang.Custom')}}
            </div>
            <div @click="TimeSelectCancel">
              <i class="iconfont icon-a-closethick"></i>
            </div>
          </div>
          <div class="CustomTimeContent">
            <div class="title">{{$t('lang.Until')}}</div>
            <el-date-picker
              popper-class="pick_date_timebk"
              v-model="BreakingSourceSetting.endTime"
              type="datetime"
              value-format="timestamp"
              :format="PickerFormat.DateTime"
            >
            </el-date-picker>
            <i class="el-icon-date"></i>
          </div>
          <div class="BottomBtn">
            <el-button
              size="small"
              class="cancelButton"
              @click="TimeSelectCancel">{{ $t("lang.cancel") }}</el-button>
            <el-button
              size="small"
              type="primary"
              class="saveButton"
              @click="TimeSelectSave">{{ $t("lang.ConfirmBtn") }}</el-button>
          </div>
      </div>
      <div class="dialog-footer" slot="footer">
        <el-button
          size="small"
          class="cancelButton"
          @click="BreakingSourceSwitch = false"
          >{{ $t("lang.cancel") }}</el-button
        >
        <el-button
          size="small"
          class="ClearFields"
          @click="ClearFields"
          >{{ $t("lang.ClearFields") }}</el-button
        >
        <el-button
          size="small"
          type="primary"
          class="saveButton"
          @click="save"
          >{{ $t("lang.ConfirmBtn") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import toTips from '@/assets/js/toTipsObj'
import Outil from '@/assets/js/utils.js'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      // 是否显示图标
      IsShowIcon: false,
      // 设置开关
      BreakingSourceSwitch: false,
      // 时间选择开关
      TimeSelectSwitch: false,
      // 信息
      BreakingSourceSetting: {
        title: '',
        epgDuration: 0,
        description: '',
        endTime: ''
      },
      // 类型选择
      EPGTypeValue: 0,
      // epg类型选择
      EPGTypeList: [
        {
          value: 0,
          label: 'CutPlaylist'
        },
        {
          value: 1,
          label: 'NextEvent'
        },
        {
          value: 2,
          label: 'Custom'
        }
      ],
      // 时间格式
      PickerFormat: {
        DateTime: 'yyyy-MM-dd h:mm:ss A'
      }
    }
  },
  computed: {
    ...mapState({
      State: (state) => state
    })
  },
  watch: {
    // 行为同步
    'State.BehaviorChange' (data) {
      console.log('pla-right')
      if (data.action == 'playoutPreviewStatusModule') {
        // data.status == 0 表示结束, 4BreakingSource
        if (data.status == 4) {
          this.IsShowIcon = true
        } else {
          this.IsShowIcon = false
        }
      }
    }
  },
  created () {
    // 获取时间格式
    this.PickerFormat = Outil.getDateTimePickerFormat()
    // this.getBreakingSource()
  },
  methods: {
    // 打开设置
    OpenSetting () {
      this.BreakingSourceSwitch = true
      this.getBreakingSource()
    },
    // epg类型选择变化
    EPGTypeChange (key) {
      this.BreakingSourceSetting.epgDuration = key
      this.TimeSelectSwitch = key == 2
    },
    // 获取BreakingSourceEpg信息
    getBreakingSource () {
      const programId = this.$BehaviorSyns.getProgramId()
      if (!programId) return
      this.axios({
        method: 'post',
        url: Outil.getUrl('/EPG/getBreakSourceEPG'),
        data: { programId }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          this.BreakingSourceSetting = res.data.result
          this.BreakingSourceSetting.endTime = this.BreakingSourceSetting.endTime || ''
          this.EPGTypeGive()
          this.IsShowIcon = true
        } else {
          this.BreakingSourceSetting = {
            title: '',
            epgDuration: 0,
            description: '',
            endTime: ''
          }
          this.IsShowIcon = false
          if (res.data.errorCode == '80602014') {
            this.$message.info(this.$t('lang.NoBreakingSource'))
            return
          }
          const errorInfo =
          this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // 类型赋值
    EPGTypeGive () {
      this.EPGTypeValue = this.BreakingSourceSetting.epgDuration
      if (this.EPGTypeValue == 2) {
        const Time = Outil.TransitionCurrentTime1(new Date(this.BreakingSourceSetting.endTime))
        this.EPGTypeValue = `Until ${Time}`
      }
    },
    // 时间选择取消
    TimeSelectCancel () {
      if (this.BreakingSourceSetting.endTime) {
        this.TimeSelectSwitch = false
        this.EPGTypeGive()
      } else {
        this.TimeSelectSwitch = false
        this.EPGTypeValue = 0
        this.BreakingSourceSetting.epgDuration = 0
      }
    },
    // 时间选择保存
    TimeSelectSave () {
      if (this.BreakingSourceSetting.endTime) {
        this.TimeSelectSwitch = false
        this.EPGTypeGive()
      } else {
        this.$message.warning(this.$t('lang.CustomTimeSelect'))
      }
    },
    ClearFields () {
      this.EPGTypeValue = 0
      this.BreakingSourceSetting.epgDuration = 0
      this.BreakingSourceSetting.description = ''
      this.BreakingSourceSetting.endTime = ''
    },
    save () {
      const programId = this.$BehaviorSyns.getProgramId()
      if (!programId) return
      if (this.BreakingSourceSetting && !this.BreakingSourceSetting.eventId) {
        this.$message.info(this.$t('lang.NoBreakingSource'))
        return
      }
      this.axios({
        method: 'post',
        url: Outil.getUrl('/EPG/saveBreakSourceEPG'),
        data: {
          ...this.BreakingSourceSetting,
          programId
        }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          this.BreakingSourceSwitch = false
        } else {
          const errorInfo =
          this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped lang="less">
#BreakingSourceEpg{
  .shezhi{
    width: 26px;
    height: 26px;
    text-align: center;
    line-height: 26px;
    border: 1px solid #666666;
    font-size: 14px;
    color: #dfdfdf;
    margin-left: 10px;
  }
  .BreakingSourceSetting{
    text-align: left;
    .formTitle {
      font-size: 14px;
      color: #DBDBDB;
      line-height: 17px;
      margin-bottom: 5px;
      span {
        color: #E56464;
      }
    }
    ::v-deep .formInput {
      margin-bottom: 10px;
      .el-input__inner {
        background: #444444;
        border-radius: 4px;
        border: 1px solid #353535;
        color: #DBDBDB;
      }
      .el-textarea__inner {
        background: #444444;
        border-radius: 4px;
        border: 1px solid #353535;
        color: #DBDBDB;
      }
      input::-webkit-input-placeholder {
        color: #666666;
      }
    }
    #formInput {
      ::v-deep .el-select {
        width: 100%;
        padding-left: 0px;
        .el-input__inner {
          background: #444444;
          border-radius: 4px;
          border: 1px solid #353535;
          color: #DBDBDB;
        }
      }
    }
  }
  .CustomTime{
    position: absolute;
    top: 0;
    left: 103%;
    background: #252525;
    width: 288px;
    padding: 0 24px;
    text-align: left;
    border-radius: 6px;
    .CustomTimeHead{
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 2px solid #444444;
    }
    .CustomTimeContent{
      position: relative;
      .title{
        margin: 16px 0 12px;
        font-size: 14px;
        line-height: 16px;
        color: #DBDBDB;
      }
      ::v-deep .el-date-editor{
        .el-input__inner{
          border: none;
          width: 240px;
          height: 32px;
          background: #444444;
          padding-left: 10px;
        }
        .el-input__prefix{
          display: none;
        }
      }
      .el-icon-date{
        position: absolute;
        right: 8px;
        top: 37px;
      }
    }
  }
  ::v-deep .el-dialog__footer,.BottomBtn{
    text-align: right;
    padding: 24px 0px;
    .el-button{
      height: 32px;
      border-radius: 4px;
      font-size: 14px;
      color: #DBDBDB;
      padding: 0;
      text-align: center;
      line-height: 32px;
      margin-left: 16px;
    }
    .cancelButton{
      width: 80px;
      background: #666666;
    }
    .ClearFields{
      width: 110px;
      background: #666666;
    }
    .saveButton{
      width: 80px;
      background: #33AB4F;
    }
  }
}

</style>
